import React from 'react'

const Footer = () => {
    return (
        <footer>
            <div className="footer-container">
                <p>Project réaliser par Frédérick Ponchateau - 2021</p>
                <p>Les icônes Wolverine, Iron-man, Spider-man, batman sont prise sur iconFinder.com</p>
            </div>
        </footer>
    )
}

export default Footer
